import { createMiddleware } from '@tanstack/react-start'
import { requireAuth } from './auth'

export const authMiddleware = createMiddleware().server(async ({ next }) => {
  const user = await requireAuth()
  return next({ context: { user } })
})
